<template>
 <div class="bg-white p-4 rounded-lg shadow">
  <apexchart type="heatmap" :options="chartOptions" :series="series" />
 </div>
</template>

<script>
export default {
 name: "HeatmapChart",
 props: {
  series: {
   type: Array,
   required: true,
  },
  categories: {
   // X-axis categories (time periods)
   type: Array,
   required: true,
  },
  title: {
   type: String,
   // Updated default title to reflect user-queue connection minutes
   default: "User Connection Minutes per Queue per Hour",
  },
 },
 computed: {
  chartOptions() {
   return {
    chart: {
     height: 300,
     type: "heatmap",
     toolbar: { show: false },
    },
    dataLabels: { enabled: false },
    colors: ["#3b82f6"],
    plotOptions: {
     heatmap: {
      shadeIntensity: 0.5,
      colorScale: {
       ranges: [
        { from: 0, to: 30, color: "#ef4444" },
        { from: 31, to: 60, color: "#f59e0b" },
        { from: 61, to: 80, color: "#10b981" },
        { from: 81, to: 100, color: "#059669" },
       ],
      },
     },
    },
    title: {
     text: this.title,
     align: "left",
     style: {
      fontSize: "16px",
      color: "#333",
     },
    },
    subtitle: {
     text: this.$t("connectionIntensityByHour"),
    },
    xaxis: {
     categories: this.categories,
     title: { text: "Time Period" },
    },
    tooltip: {
     y: {
      formatter: function (val) {
       return val + "%";
      },
     },
    },
   };
  },
 },
};
</script>
